import { Select } from '../../input/Select';

export const AIInput = ({ params, onChange }) => (
  <Select
    label="AI"
    value={params.ai?.model}
    onChange={(val) => onChange('ai', { model: val })}
    style={{ width: 120 }}
    choices={[
      {
        name: 'OpenAI',
        choices: [
          ['openai:gpt-4o', 'GPT-4o'],
          ['openai:gpt-4o-mini', 'GPT-4o mini'],
          ['openai:gpt-4.1', 'GPT-4.1'],
          ['openai:gpt-4.1-mini', 'GPT-4.1 mini'],
          ['openai:gpt-4.1-nano', 'GPT-4.1 nano'],
        ],
      },
    ]}
  />
);
